import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["share"];

  static values = {
    inactive: {
      type: String,
      default: "Do you want to share anything else?",
    },
    active: { type: String, default: "What else would you like to share?" },
  };

  connect() {
    console.log("TitleChangeController connected");
    // find the check-in-free_response-heading h1 element
    const heading = document.querySelector(
      "#check-in-free_response-heading > h1 > p",
    );
    console.log(heading);
    // if the share target checkbox is checked, set the share target text content to active
    if (this.shareTarget.checked) {
      heading.textContent = this.activeValue;
    }
  }

  toggle() {
    const heading = document.querySelector(
      "#check-in-free_response-heading > h1 > p",
    );
    if (this.shareTarget.checked) {
      heading.textContent = this.activeValue;
    } else {
      heading.textContent = this.inactiveValue;
    }
    console.log(heading, this.inactiveValue, this.activeValue);
  }
}
